"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _admin = require("../../reducers/admin.js");
var _uberAdminProps = _interopRequireDefault(require("./uberAdminProps.js"));
var _questAdminProps = _interopRequireDefault(require("./questAdminProps.js"));
var _noManageOrganizationProps = _interopRequireDefault(require("./noManageOrganizationProps.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;
var questOrgGroup = AppDefs.pawn.groups.find(function (item) {
  return item.handle === 'questorganization';
});
var questProjectGroup = AppDefs.pawn.groups.find(function (item) {
  return item.handle === 'questproject';
});
var questAdminPawn = AppDefs.pawn.roles.find(function (item) {
  return item.handle === 'questprojectadmin';
});
var ManageProjects = function ManageProjects(props) {
  var isSuperUser = Fortress.isSuperUser();
  var isUber = Fortress.settings.role === 'uberadmin';
  var hasManageOrgsPermission = Fortress.hasAccess('quest.manage_orgs');
  var componentProps;
  if (isUber) {
    if (isSuperUser || hasManageOrgsPermission) {
      componentProps = _uberAdminProps["default"];
    } else {
      componentProps = _noManageOrganizationProps["default"];
    }
  } else {
    componentProps = _questAdminProps["default"];
  }
  var addAppDefLabels = function addAppDefLabels(settings) {
    var settingsString = JSON.stringify(settings);
    var labelVars = [{
      variable: '@groupType:one:questorganization@',
      label: questOrgGroup.label
    }, {
      variable: '@groupType:many:questorganization@',
      label: questOrgGroup.labelPlural
    }, {
      variable: '@groupType:one:questproject@',
      label: questProjectGroup.label
    }, {
      variable: '@groupType:many:questproject@',
      label: questProjectGroup.labelPlural
    }, {
      variable: '@role:one:questprojectadmin@',
      label: questAdminPawn.label
    }, {
      variable: '@role:many:questprojectadmin@',
      label: questAdminPawn.labelPlural
    }];
    labelVars.forEach(function (item) {
      settingsString = settingsString.replace(new RegExp(item.variable, 'g'), item.label);
    });
    return JSON.parse(settingsString);
  };
  var addLoginAs = function addLoginAs(settings) {
    if (isSuperUser) {
      try {
        settings.verticalNav.find(function (n) {
          return n.handle === 'admin_manage_questprojectadmins';
        }).contentConfig.tableTop.views[0].table.columns.find(function (col) {
          return col.handle === 'actions';
        }).renderAs.settings.buttons.splice(3, 0, {
          type: 'loginAs',
          label: '',
          className: 'btn-xs btn-warning',
          withTooltip: true,
          tooltipText: 'Login As'
        });
      } catch (e) {
        // meh, no big deal
      }
    }
    return settings;
  };
  var checkTrialMode = function checkTrialMode(settings) {
    try {
      if (AppDefs.app.isQuestFreeTrial && !isSuperUser) {
        var config = settings.verticalNav.find(function (nav) {
          return nav.handle === 'admin_manage_questprojectadmins';
        }).contentConfig;
        config.disableAddButton = true;
        config.disableAddButtonTooltip = 'This feature is not available during trial period.';
      }
    } catch (e) {
      // meh, no big deal
    }
    return settings;
  };
  var actualProps = addAppDefLabels(componentProps);
  actualProps = addLoginAs(actualProps);
  actualProps = checkTrialMode(actualProps);
  var dispatch = (0, _reactRedux.useDispatch)();
  var externalLoadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch((0, _admin.loadProjectList)({
              forceReload: true
            }));
            dispatch((0, _admin.reloadCurrentProject)());
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function externalLoadData() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.Manage, _extends({}, props, actualProps, {
    externalLoadData: externalLoadData
  }));
};
var _default = exports["default"] = ManageProjects;